import {
  FILE_VALIDATER,
  GET_JOB_STATUS_DETAILS
} from '../constants/actionTypes';
import api from '../api';

export const fileValidaterFunction = (formData) => (dispatch) => {
  return dispatch(
    api.fetch(
      FILE_VALIDATER,
      api.config.fileValidation(),
      api.http.postForm(formData)
    )
  ).catch((error) => {
    console.log(error);
  });
};

export const fetchJobDetails = (userId, pageNumber, sortType = "DESC", sortId = "uploadedDate") => (dispatch) => {
  return dispatch(
    api.fetch(
      GET_JOB_STATUS_DETAILS,
      api.config.getJobStatus(userId, pageNumber, sortType, sortId),
      api.http.get()
    )
  );
};
